import isAfter from 'date-fns/isAfter'
// import { removeTime } from '@/utils/date'
import { formatDisplayDate, removeTime } from '@/utils/date'

function getMessage(field, args) {
  var effDate = formatDisplayDate(args[0])
  // return `Cannot be later than Expiry Date (10109)`
  return `Cannot be earlier than Scheme Effective Date ${effDate}`
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var effDate = args[0]
    if (effDate) {
      // if (isAfter(removeTime(effDate), removeTime(value))) {
      //   return false
      // } else {
      //   return true
      // }
      return !(isAfter(removeTime(effDate), removeTime(value)))
    } else {
      return true
    }
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
